import React, { useState } from "react";
import SearchIcon from "../Assets/images/searchicon.png";
import FREEIMAGE from "../Assets/images/free-banner.png";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect } from "react";
import FreeImageForm from "../Modals/FreeImageForm";
import { toast } from "react-toastify";
import { Box, ClickAwayListener, debounce, Typography } from "@mui/material";
import { appSettingDataSelector } from "../../redux/appSetting";
import { useSelector } from "react-redux";
import { fetchFile, getFilterdData, toTitleCase } from "../../lib/helper";
import ImageMenu from "./ImageMenu";
import { ReactComponent as DownloadIcon } from "../Assets/svgs/download-menu.svg";
import { ReactComponent as DownArrow } from "../Assets/svgs/down-arrow-filled.svg";
import { autosuggest } from "../../services/SearchApi";

const StarsSearchBar = ({
  isDownloadButton,
  showTitleHeader,
  imageData,
  isSearchtext,
  isMoreInfoWall,
  shootId,
  imageAlignment,
  imageUrl,
  isColor,
  layoutHeroClass,
  imageid,
  FullImageWall,
  enableBackground,
  animationStyle,
  animationDropDownStyle,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [freeWeeklyImage, setFreeWeeklyImage] = useState("");
  const [freeImageValidity, setFreeImageValidity] = useState("");
  const [openFreeImageForm, setOpenFreeImageForm] = React.useState(false);
  const [divShow, setDivShow] = useState(false);
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const [selectedSearchOption, setSelectedSearchOption] = useState("Images");
  const [searchText, setSearchText] = useState("");
  const { searchKeyword } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedMenuType = searchParams.get("menu_type");
  const isBrowseCategory = searchParams.get("br");
  const isSearchContent = searchParams.get("sc");
  const { appSettingData } = useSelector(appSettingDataSelector);
  const [autoComplete, setAutoComplete] = useState([]);
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [cursor, setCursor] = useState(-1);
  const handleKeyDown = (e) => {
    if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < autoComplete.length - 1) {
      setCursor(cursor + 1);
    }
    if (e.keyCode == 13) {
      setShowAutoComplete(false);
      if (autoComplete[cursor]) {
        setSearchText(autoComplete[cursor]?.displayKeyword);
        navigate(`/stars/search/${autoComplete[cursor]?.displayKeyword}?sc=1`);
      } else {
        navigate(`/stars/search/${searchText}?sc=1`);
      }
    }
  };

  useEffect(() => {
    if (searchKeyword !== undefined && isBrowseCategory != 1) {
      setSearchText(searchKeyword);
      setCursor(-1);
    }
    if (isBrowseCategory == 1) {
      if (isSearchContent != 1) {
        setSearchText("");
      } else {
        if (searchKeyword !== undefined) {
          setSearchText(searchKeyword);
          setCursor(-1);
        }
      }
    }
  }, [location]);
  useEffect(() => {
    document.onclick = (args) => {
      if (autoComplete) {
        setShowAutoComplete(false);
      }
    };
  }, []);

  return (
    <>
      <Box component="div">
        {isSearchtext && (
          <>
            <div className="searchInput">
              <div className="mainDivSearchBar">
                <div className="searchBarItems" id="autoCompleteDiv">
                  <span className="searchIcon">
                    <img
                      onClick={() => {
                        setShowAutoComplete(false);
                        navigate(`/stars/search/${searchText}?sc=1`);
                      }}
                      style={{ cursor: "pointer" }}
                      src={SearchIcon}
                      alt="SearchIcon"
                    />
                  </span>
                  <input
                    type="text"
                    className="searchInputType mainpagetitle"
                    placeholder="Search the largest collection of Indian images"
                    onChange={(event) => {
                      setSearchText(event.target.value);
                      if (event.target.value && event.target.value.length > 0) {
                        let callSearch = debounce(async function () {
                          let res = await autosuggest(event.target.value);
                          setAutoComplete(res?.rows);
                          setShowAutoComplete(true);
                        }, 150);
                        callSearch();
                      } else {
                        setAutoComplete([]);
                      }
                    }}
                    style={animationStyle}
                    value={searchText}
                    autoComplete="off"
                    onFocus={(event) => {
                      if (searchText && searchText.length > 0) {
                        let callSearch = debounce(async function () {
                          let res = await autosuggest(searchText);
                          setAutoComplete(res?.rows);
                          setShowAutoComplete(true);
                        }, 150);
                        callSearch();
                      } else {
                        setAutoComplete([]);
                      }
                    }}
                    onKeyDown={handleKeyDown}
                  />
                  {autoComplete?.length && showAutoComplete ? (
                    <div
                      className="autocomplete"
                      style={animationDropDownStyle}
                    >
                      {autoComplete?.map((item, index) => {
                        return (
                          <div
                            className={`autocomplete_inner ${
                              cursor === index ? "active" : null
                            }`}
                            key={Math.random().toString()}
                            onClick={async () => {
                              setSearchText(item?.displayKeyword);
                              setShowAutoComplete(false);
                              navigate(`/stars/search/${item?.displayKeyword}`);
                            }}
                          >
                            {item?.displayKeyword}
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </>
        )}
      </Box>
    </>
  );
};

export default StarsSearchBar;
